<div class="component-container">


<!-- Navbar -->

<nav class="navbar">
    <div class="navbar-container">
        <!-- Logo -->
        <a class="logo">

            <img src="assets/price_matcher_icon.png" alt="logo">
            <div class="logo-text">PRICE<span>MATCHER</span></div>
        </a>

        <!-- Desktop Navigation Links -->
        <ul class="nav-links">
            <li><a [routerLink]="['/login']" [class.active]="activeSection === 'home'" (click)="selectSection($event, 'home')" >Home</a></li>
            <li><a href="#" [class.active]="activeSection === 'features'" (click)="selectSection($event, 'features')" >Features</a></li>
            <li><a [routerLink]="['/pricing']" [class.active]="activeSection === 'pricing'" (click)="selectSection($event, 'pricing')" >Pricing</a></li>
            <li><a [routerLink]="['/about']" [class.active]="activeSection === 'about'" (click)="selectSection($event, 'about')" >About</a></li>
            <li><a [routerLink]="['/contact']" [class.active]="activeSection === 'contact'" (click)="selectSection($event, 'contact')" >Contact</a></li>
        </ul>

        <!-- Desktop Auth Buttons (Signed Out State) -->
        <div class="auth-buttons" id="authButtons">
            <a [routerLink]="['/login']" class="btn btn-secondary">Sign In</a>
            <a [routerLink]="['/register']" class="btn btn-primary">Sign Up</a>
        </div>

        <!-- Desktop User Menu (Signed In State) -->
        <div class="user-menu" id="userMenu">
            <div class="user-avatar" id="userAvatar">
                <img src="https://i.pravatar.cc/100" alt="User avatar">
            </div>
            <div class="user-dropdown" id="userDropdown">
                <a [routerLink]="['/']">App</a>
                <a href="#">Dashboard</a>
                <a [routerLink]="['/settings']">Settings</a>
                <hr>
                <a href="#">Sign Out</a>
            </div>
        </div>

        <!-- Mobile Hamburger Menu -->
        <div class="hamburger" id="hamburger">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>
</nav>

<!-- Mobile Drawer -->
<div class="mobile-drawer" id="mobileDrawer">
    <div class="drawer-header">
        <div class="logo-text">DARK<span>UI</span></div>
        <button class="drawer-close" id="drawerClose">&times;</button>
    </div>

    <!-- Mobile User Info (Signed In State) -->
    <div class="mobile-user-info" id="mobileUserInfo">
        <div class="mobile-user-header">
            <div class="mobile-user-avatar">
                <img src="https://i.pravatar.cc/100" alt="User avatar">
            </div>
            <div class="mobile-user-details">
                <h3>John Doe</h3>
                <p>john.doe&#64;example.com</p>
            </div>
        </div>
    </div>

    <!-- Mobile Navigation Links -->
    <ul class="mobile-nav-links">
        <li><a [routerLink]="['/login']" [class.active]="activeSection === 'home'" (click)="selectSection($event, 'home')">Home</a></li>
        <li><a href="#">Features</a></li>
        <li><a [routerLink]="['/pricing']" [class.active]="activeSection === 'pricing'" (click)="selectSection($event, 'pricing')">Pricing</a></li>
        <li><a [routerLink]="['/about']" [class.active]="activeSection === 'about'" (click)="selectSection($event, 'about')">About</a></li>
        <li><a [routerLink]="['/contact']" [class.active]="activeSection === 'contact'" (click)="selectSection($event, 'contact')">Contact</a></li>
    </ul>

    <!-- Mobile Auth Buttons (Signed Out State) 
    <div class="mobile-auth-buttons" id="mobileAuthButtons">
        <a href="#" class="btn btn-secondary">Sign In</a>
        <a href="#" class="btn btn-primary">Sign Up</a>
    </div>
    -->

    <!-- Mobile User Actions (Signed In State) -->
    <div class="mobile-auth-buttons" id="mobileUserActions">
        <a href="#" class="btn btn-secondary">App</a>
        <a href="#" class="btn btn-secondary">Dashboard</a>
        <a href="#" class="btn btn-secondary">Settings</a>
        <a href="#" class="btn btn-primary">Sign Out</a>
    </div>
</div>

<!-- Overlay for Mobile Drawer -->
<div class="overlay" id="overlay"></div>

<!-- Page Content (for demo) -->
<div class="page-content">
    <h1>Welcome to DarkUI</h1>
    <p>This is a responsive navbar with dark theme that includes a logo, navigation links, and authentication buttons. On mobile devices, it transforms into a hamburger menu that opens a drawer with all navigation options.</p>
    <p>The navbar has two states: signed out (showing Sign In/Sign Up buttons) and signed in (showing user avatar with dropdown). You can toggle between these states using the switch at the bottom right of the page.</p>
    <router-outlet></router-outlet>
</div>

<!-- Demo Toggle (for demonstration purposes) -->
<div class="demo-toggle">
    <label>
        <input type="checkbox" id="signedInToggle">
        <span>Signed In</span>
    </label>
</div>
</div>